import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import  Bar  from './bar';
import Cajon from './cajon';
import FindHistories from '../pages/FindHistories'

import { Hidden } from '@material-ui/core';
import FindPatients from '../pages/FindPatients';
import CreateHistory from './createHistory';
import UpdateHistoryMedical from './UpdateHistoryMedical';
import FindMedicalTeam from '../pages/FindMedicalTeam';
import GeneratePdf from './generatePdf'
import CreatePersonalTeam from './createPersonalTeam';
import CreatePatient from './createPatient';
import FindAgenda from '../pages/FindAgenda';
import CreateAgenda from './agenda';
import CloseHistory from './CloseHistory';
import UpdateHistoryTherapy from './UpdateHistoryTherapy';
import AssignPatients from './AssignPatients';
import UpdateHistoryNurse from './UpdateHistoryNurse';
import UpdateHistorySocialWorker from './UpdateHistorySocialWorker';
import AddAuxHistoryMedical from './AddAuxHistoryMedical';
import ChangePasswordPersonalTeam from './ChangePasswordPersonalTeam';
import UpdateHistoryNutriocionista from './UpdateHistoryNutriocionista';
import UpdateHistoryLaboral from './UpdateHistoryLaboral';



const estilos = makeStyles( theme => ({
    root: {
        display: 'flex'
    },
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
   
  }));

 

const Contenedor = (props) => {
    const classes = estilos()
    const [abrir, setAbrir] = React.useState(false)
    const [orderButton, setOrderButton] = React.useState(0)
    const [indexEvolution, setIndexEvolution] = React.useState(0)
    const [comeFromMenu, setComeFromMenu] = React.useState(false)
    const [printAdditionalInfo, setPrintAdditionalInfo] = React.useState(false)

    const accionAbrir = () => {
      setAbrir(!abrir)
    }

 

    const changeMenu = (order)  => {
      setOrderButton(order);
    }
    const [affiliateInfo, setAffiliateInfo] = React.useState({ id: "" })
    
    const setAffiliate = (affiliate) => {
        setAffiliateInfo(affiliate)
    }

    const [medical, setMedical] = React.useState({ id: "" })
    
    const setMedicalTeam = (medical) => {
      setMedical(medical)
    }

    const [returnPageId, setReturnPageId] = React.useState(0)
    

    const setActionMenu = ()  => {
      switch(orderButton) {
        case 1: return <ChangePasswordPersonalTeam changeMenu={changeMenu} medical={props.user}></ChangePasswordPersonalTeam>
       // case 1: return <FindAgenda changeMenu={changeMenu} setAffiliate={setAffiliate} setMedicalTeam={setMedicalTeam} />
        case 2: return <FindHistories changeMenu={changeMenu} setAffiliate={setAffiliate} 
              setReturnPageId={setReturnPageId}
              setIndexEvolution={setIndexEvolution}
              setComeFromMenu={setComeFromMenu} user={props.user}/>
        case 3: return <FindPatients changeMenu={changeMenu} setAffiliate={setAffiliate} 
        returnPageId={returnPageId} comeFromMenu={comeFromMenu} />
        case 4: return <FindMedicalTeam changeMenu={changeMenu} 
        setMedicalTeam={setMedicalTeam} comeFromMenu={comeFromMenu}/>
        case 5: return <CreateHistory changeMenu={changeMenu} affiliateInfo={affiliateInfo} 
        setAffiliate={setAffiliate} user={props.user} setIndexEvolution={setIndexEvolution}/> 
        case 6: return <UpdateHistoryMedical  changeMenu={changeMenu} affiliateInfo={affiliateInfo} 
                        setAffiliate={setAffiliate} indexEvolution={indexEvolution}
                        setIndexEvolution={setIndexEvolution} user={props.user} 
                        setPrintAdditionalInfo={setPrintAdditionalInfo}/>
        case 7: return <UpdateHistoryTherapy affiliateInfo={affiliateInfo} changeMenu={changeMenu}
                        setAffiliate={setAffiliate} indexEvolution={indexEvolution}
                        setIndexEvolution={setIndexEvolution} /> 
        case 8: return <GeneratePdf affiliateInfo={affiliateInfo} indexEvolution={indexEvolution}/> 
        case 9: return <CreatePersonalTeam changeMenu={changeMenu} medical={medical}></CreatePersonalTeam>
        case 10: return <CreatePatient changeMenu={changeMenu} affiliateInfo={affiliateInfo}></CreatePatient>
        case 11: return <CreateAgenda changeMenu={changeMenu} affiliateInfo={affiliateInfo}
          medical={medical} setReturnPageId={setReturnPageId}
          setComeFromMenu={setComeFromMenu}></CreateAgenda>
        case 12: return <CloseHistory  affiliateInfo={affiliateInfo} indexEvolution={indexEvolution} printAdditionalInfo={printAdditionalInfo}></CloseHistory>
        case 13:  return <AssignPatients changeMenu={changeMenu} affiliateInfo={affiliateInfo}
        medical={medical} setReturnPageId={setReturnPageId}
        setComeFromMenu={setComeFromMenu}></AssignPatients>
        case 14: return <UpdateHistoryNurse affiliateInfo={affiliateInfo} changeMenu={changeMenu}
                        setAffiliate={setAffiliate} indexEvolution={indexEvolution}
                        setIndexEvolution={setIndexEvolution} /> 
        case 15: return <UpdateHistorySocialWorker affiliateInfo={affiliateInfo} changeMenu={changeMenu}
                        setAffiliate={setAffiliate} indexEvolution={indexEvolution}
                        setIndexEvolution={setIndexEvolution} />  
        case 16: return <AddAuxHistoryMedical changeMenu={changeMenu} affiliateInfo={affiliateInfo} 
                        setAffiliate={setAffiliate} indexEvolution={indexEvolution}
                        setIndexEvolution={setIndexEvolution} user={props.user} 
                        setPrintAdditionalInfo={setPrintAdditionalInfo}/>   
        case 17: return <UpdateHistoryNutriocionista affiliateInfo={affiliateInfo} changeMenu={changeMenu}
                        setAffiliate={setAffiliate} indexEvolution={indexEvolution} user={props.user} 
                        setIndexEvolution={setIndexEvolution} /> 
        case 18: return <UpdateHistoryLaboral  changeMenu={changeMenu} affiliateInfo={affiliateInfo} 
                        setAffiliate={setAffiliate} indexEvolution={indexEvolution}
                        setIndexEvolution={setIndexEvolution} user={props.user} />
              
        default: break;
      }
    }

    

  return (
    <div className={classes.root}>
        <Bar accionAbrir={accionAbrir} user={props.user}/>
          <Hidden xsDown>
            <Cajon variant="permanent" open={true} changeMenu={changeMenu} user={props.user} setComeFromMenu={setComeFromMenu}/>
          </Hidden>
          <Hidden smUp>
            <Cajon variant="temporary" open={abrir} onClose={accionAbrir} changeMenu={changeMenu} user={props.user} setComeFromMenu={setComeFromMenu} />
          </Hidden>
        <div className={classes.content}>
            <div className={classes.toolbar}></div>
            <div>{ setActionMenu() } </div>
            
        </div>
    </div>
  )
}

export default Contenedor;
